import { THEME_CSS_VARIABLES, validateThemePatch, type ValidatedTheme } from '../../configuration/theme'

export function applyValidatedTheme(target: HTMLElement, input: Record<string, unknown>): ValidatedTheme {
  const theme = validateThemePatch(input)
  for (const [key, value] of Object.entries(theme.tokens)) {
    if (!value) continue
    target.style.setProperty(THEME_CSS_VARIABLES[key as keyof typeof THEME_CSS_VARIABLES], value)
  }
  return theme
}

export function clearCustomTheme(target: HTMLElement): void {
  for (const cssVariable of Object.values(THEME_CSS_VARIABLES)) target.style.removeProperty(cssVariable)
}
